import '../sass/main.scss';
import { getMenuColumnLimit, computeMenuColumns, eventMonthLabel } from './lib/menu.mjs';

function InitializePage($, Drupal, DrupalSettings) {
    $(document).ready(() => {
        const headerContentContainer = $("header .header__main .navigation.block-menu > .content");
        const menuColumnLimit = getMenuColumnLimit(DrupalSettings);

        function closeHeaderContainer() {
            headerContentContainer.removeClass("is-mega-menu");
            headerContentContainer.css("height", "auto");
        }

        function openMegaMenu(item) {
            headerContentContainer.addClass("is-mega-menu");

            const subMenu = $("ul.menu--level-1", item);
            subMenu.show();

            $("ul.menu--level-1", headerContentContainer).each(function () {
                const menuChildren = $(this).children();
                if (menuChildren.length <= 10) return;

                const isSub = menuChildren.toArray().map((child) => $(child).hasClass("sub"));
                let start = 0;
                for (const size of computeMenuColumns(isSub, menuColumnLimit)) {
                    menuChildren.slice(start, start + size).wrapAll($("<div/>", { "class": "mega-menu__column" }));
                    start += size;
                }
            });

            const subMenuHeight = subMenu.height();
            $(item).height() < subMenuHeight ? headerContentContainer.height(subMenuHeight + subMenu.offset().top) : headerContentContainer.css("height", "auto");

            if ($(subMenu).children("li").length > 0) {
                const firstLevelMenu = $(".menu.menu--level-0", headerContentContainer);
                const firstLevelChild = $(" > li:first-child", firstLevelMenu);
                const firstLevelMenuWidth = headerContentContainer.width() - firstLevelMenu.width() + firstLevelChild.width();
                firstLevelChild.width(firstLevelMenuWidth - 1);
            }
        }

        $(">ul > li", headerContentContainer)
            .on("keydown", function(event) {
                const atag = $(">a", this);
                if (atag.length <= 0) return;
                const keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode === 13) {
                    if (event.target !== atag[0]) return;
                    $("ul.menu--level-1", headerContentContainer).each((i, smenu) => $(smenu).hide());
                    closeHeaderContainer();
                    event.preventDefault();
                    openMegaMenu(this);
                }
            })
            .on("mouseenter", function () {
                if ($(this).children("ul").length) {
                    openMegaMenu(this);
                    return;
                }
                closeHeaderContainer();
            })
            .on("mouseleave", function()
            {
                $("ul.menu--level-1", this).hide();
                $("#header .menu.menu--level-0 > li:first-child").width("auto");
                if(!$(this).parent().is(":hover")) closeHeaderContainer();
            });
        $(".menu .menu--level-1", headerContentContainer).on("mouseleave", function() {
            if ($(this).parent().is(":hover")) return;
            closeHeaderContainer();
        });
        headerContentContainer.on("mouseleave", closeHeaderContainer);

        const searchForm = $(".search-toggle");

        const searchFormShow = $(".search-toggle__open", searchForm);
        searchFormShow.on("click keyup", function (event) {
            if (event.type === "keyup" && event.which !== 13) return;
            $(this).hide();
            $('.search-toggle__field', searchForm).animate({
                width: "toggle"
            }, 300);
            $('.search-toggle__submit', searchForm).animate({
                width: "toggle"
            }, 300);
        });

        const currentLanguage = DrupalSettings?.path?.currentLanguage ?? 'lv';

        const eventsBlock = $("div.events-block");
        $(".views-row", eventsBlock).each(function() {
            const eventDayField = $(".views-field-field-date-from", this);
            const eventMonthField = $(".views-field-field-date-from-1", this);

            const eventDate = new Date($("time", eventDayField).attr("datetime"));
            const currentDate = new Date();

            if (currentDate > eventDate) {
                eventDayField.addClass("active-event");
            }
            $("time", eventDayField).text(eventDate.getDate())
            $("time", eventMonthField).text(eventMonthLabel(eventDate, currentLanguage));
        });

        const mainHeader = $("#header");
        const mobileHeader = $("#header-mobile");

        const cartBlock = $("#block-cart");
        if (cartBlock.length) {
            cartBlock.clone().appendTo("#header-mobile").addClass("header-mobile__cart");
        }

        $(".header__secondary .language-selector", mainHeader)
            .clone().appendTo("#header-mobile .header-mobile__languages");

        $(`.header-mobile__languages ul li[hreflang='${currentLanguage}'] a`, mobileHeader)
            .clone().prependTo("#header-mobile .header-mobile__languages").addClass("header-mobile__lang-toggle");
        const langDropdownText = $("a.header-mobile__lang-toggle", mobileHeader);
        langDropdownText.text(langDropdownText.text().substring(0, 3));
        langDropdownText.attr("href", "#");

        $(".header__main .site-branding", mainHeader)
            .clone().appendTo("#header-mobile .header-mobile__logo");

        $(".header__secondary nav.block-menu .content ul", mainHeader).clone().appendTo("nav#quick-nav-mobile");
        $(".header__main nav.block-menu ul.menu.menu--level-0", mainHeader).clone().appendTo("nav#nav-mobile");
        $("nav#nav-mobile ul.menu.menu--level-0>li").has("ul").prepend('<div class="mobile-nav__toggle"></div>');
        $("nav#nav-mobile ul.menu--level-1 > li").has("ul").prepend('<div class="mobile-nav__subtoggle"></div>');
        $(".mobile-nav__toggle, .mobile-nav__subtoggle").on("click", function () {
            const btnSubMenu = $(this).next().next();
            if (btnSubMenu.is(":visible"))
            {
                btnSubMenu.slideUp();
                $(this).removeClass("rotated");
            } else {
                btnSubMenu.slideDown();
                $(this).addClass("rotated");
            }
        });

        $("a.header-mobile__lang-toggle").on("click", function () {
            const langSelector = $(".header-mobile__languages ul.language-selector");
            langSelector.is(":visible") ? langSelector.slideUp() : langSelector.slideDown()
        });
        $(".header-mobile__menu-btn").on("click", function () {
            $("nav#nav-mobile").slideDown();
            $("#page-wrapper").hide();
        });
        $(".header-mobile__quick-menu-btn").on("click", function () {
            $("nav#quick-nav-mobile").slideDown();
            $("#page-wrapper").hide();
        });
        $(".mobile-nav__close").on("click", function () {
            $("#page-wrapper").show();
            $("nav#nav-mobile").slideUp();
            $("nav#quick-nav-mobile").slideUp();
        });
    });
}

InitializePage(jQuery, Drupal, drupalSettings);
